import React from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';
import SchoolIcon from '@mui/icons-material/School';
import PersonIcon from '@mui/icons-material/Person';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

import { AuthContext } from "../../contexts/auth";
import MyLabel from "../myLabel";
import MyImage from "../myImage";

import Styles from "./style";
import TELAS from "../../constants/telas";
import TELAS_ACOES from "../../constants/telaAcoes";

const Item = ({item, navigate, style, permissao}) =>{
  if (!permissao) return null;
  return (
    <ListItem  disablePadding>
    <ListItemButton onClick={()=>navigate(item.url)}>
        <ListItemIcon sx={style.icon}>
            {item.icon}
        </ListItemIcon>
        <ListItemText sx={style.text} primary={item.text} />
    </ListItemButton>
    </ListItem>
)
}

const MyMenu = ({ open, handleDrawerClose }) => {
    let style = Styles()
    const { user, signOut, permissaoListaFuncionalidade, permissaoUsuario } = useContext(AuthContext);
    const navigate = useNavigate();

    let menu = [
      { icon: <DashboardIcon />,text: 'Dashboard', url: "/gestor/dashboard"},
    ]

    let aplicacao = ''
    let funcionalidade = ''

    if (permissaoListaFuncionalidade.value.includes('Cursos')){
      aplicacao = "SisPalo - Colaborador"
      funcionalidade = "Cursos"

      menu.push({ icon: <PersonIcon />,text: 'Colaboradores', url: "/gestor/colaboradores", 
        permissao:permissaoUsuario.set(aplicacao, funcionalidade, TELAS.COLABORADORES, null)})

      menu.push({ icon: <SchoolIcon />,text: 'Cursos', url: "/gestor/cursos",
        permissao:permissaoUsuario.set(aplicacao, funcionalidade, TELAS.CURSOS, null)})
    }

    if (permissaoListaFuncionalidade.value.includes('Tarefas')){
       aplicacao = "SisPalo - Tarefas"
       funcionalidade = "Tarefas"
      menu.push({ icon: <AssignmentTurnedInIcon />,text: 'Tarefas', url: "/gestor/tarefas",
          permissao:permissaoUsuario.set(aplicacao, funcionalidade, TELAS.TAREFAS, null)})
      menu.push({ icon: <DirectionsCarIcon />,text: 'Checklist de Veículos', url: "/gestor/checklist-veiculos",
          permissao:permissaoUsuario.set(aplicacao, funcionalidade, TELAS.TAREFAS, TELAS_ACOES.Consultar)})
      menu.push({ icon: <ContentCopyIcon />,text: 'Template Tarefas', url: "/gestor/template",
          permissao:permissaoUsuario.set(aplicacao, funcionalidade, TELAS.TEMPLATE_TAREFAS, null)})
      menu.push({ icon: <AccountBalanceIcon />,text: 'Locais de Tarefa', url: "/gestor/localtarefa", 
          permissao:permissaoUsuario.set(aplicacao, funcionalidade, TELAS.LOCAIS_DE_TAREFAS, null)})
      menu.push({ icon: <ListAltIcon />,text: 'Agendar Relatórios', url: "/gestor/relatorios", 
          permissao:permissaoUsuario.set(aplicacao, funcionalidade, TELAS.AGENDA_RELATORIOS, null)})
    }
    if (permissaoListaFuncionalidade.value.includes('Tarefas')){
       aplicacao = "SisPalo - Gestor"
       funcionalidade = "Gestor"
        menu.push({ icon: <LockPersonIcon />,text: 'Permissões Usuário', url: "/gestor/permissoes", 
            permissao:permissaoUsuario.set(aplicacao, funcionalidade, TELAS.PERMISSOES, TELAS_ACOES.Consultar)
            
          })
        menu.push({ icon: <ManageAccountsIcon />,text: 'Usuários Clientes', url: "/gestor/usuarios-clientes",
            permissao:permissaoUsuario.set(aplicacao, funcionalidade, TELAS.PERMISSOES, TELAS_ACOES.Consultar)
          })
      }
    
  return (
    <Drawer
        variant="persistent"
        anchor="left"
        open={open}
        PaperProps={{
            sx: style.drawer}}
      >
        <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
        }}>
          <IconButton onClick={handleDrawerClose} sx={style.icon}>
            {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </Box>
        <Divider />
        <List>
            <ListItem disablePadding sx={{justifyContent:'center'}}>
              <Box sx={{backgroundColor:'white',borderRadius:'60px',  height:'120px', width:'120px', position:'relative'}}>
                  <MyImage sx={{position:'absolute', top: '10px', left: '10px', height:'100px', width:'100px'}} src={user.value.client_logo} onClick={null} alt={null}/>
              </Box>
            </ListItem>
            <ListItem disablePadding sx={{justifyContent:'center', marginBottom:'15px', marginTop:'5px'}}>
                <MyLabel text={user.value.email} sx={{color:'white', fontSize: "12pt", fontWeight: 600,}} onClick={null} variant={null} component={null}/>
            </ListItem>
            <Divider />
            {menu.map((item, key) => <Item key={key} item={item} navigate={navigate} style={style} permissao={item.permissao} />)}
        </List>
        <Divider />
        <List>
            <ListItem disablePadding>
              <ListItemButton onClick={()=>{signOut();navigate("/gestor/")}}>
                <ListItemIcon sx={style.icon}>
                   <LogoutIcon />
                </ListItemIcon>
                <ListItemText  sx={style.text} primary={'Sair'} />
              </ListItemButton>
            </ListItem>
        </List>
      </Drawer>
  );
};

export default MyMenu;

